export const getSelectValue = (conditionType: string) => {
    switch (conditionType) {
        case "Timezone":
            return "Timezone";
        case "Number Input":
            return "Number Input";
        case "Select Options":
            return "Select options";
        case "Date Input":
            return "Date Input";
        case "Select Day":
            return "Select Day";
        default:
            return "Value";
    }
};
